export const AGENTS_PAGE = 'reports/company/AGENTS_PAGE'
